module.exports = __webpack_public_path__ + "assets/img/10.e6749c68.png";